import { serverFetch } from "./serverApi";

/** Request kinds the server knows, keyed by what the admin pages call them. */
export const REQUEST_KINDS = Object.freeze({ assignment: "assignment", project: "project" });

/** Statuses that mean the work is finished one way or the other (the server only emails these). */
export const isFinalStatus = (status) => status === "completed" || status === "declined";

/**
 * Asks the server to email the user about a completed (submitted) or declined (rejected) request. The server reads the
 * real status itself and sends each outcome once. Never throws: resolves { ok, already?, message? }.
 * refundedCoins is the amount the admin panel just refunded, so the email can say so; 0 when unknown.
 */
export async function notifyRequestOutcome(kind, id, refundedCoins = 0) {
  try {
    const res = await serverFetch("/api/admin/requests/notify", { method: "POST", body: { kind, id, refundedCoins } });
    return { ok: true, already: !!res?.alreadyNotified };
  } catch (err) {
    return { ok: false, message: err?.message || "The email could not be sent." };
  }
}
